import React from 'react';
import { Section } from './Section';
import { Star, MapPin } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  location: string;
  role: string;
}
const firstTestimonials: Testimonial[] = [{
  quote: 'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Stretching en Estudio Propio'
}, {
  quote: 'Las clases con progresión real por nivel cambiaron todo. Mis alumnas mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Stretching en Centro de Adultos Mayores'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Stretching Grupal e Individual'
}];
export function Testimonials() {
  return <Section className="bg-brand-light" data-id="element-316">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-317">
        {firstTestimonials.map((t, i) => <div key={i} className="bg-brand-dark p-5 md:p-6 rounded-xl border border-white/5 shadow-xl relative" data-id="element-318">
            <div className="flex text-yellow-400 mb-3" data-id="element-319">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-320" />)}
            </div>
            <p className="text-gray-300 text-sm md:text-base italic mb-4 leading-relaxed" data-id="element-321">
              "{t.quote}"
            </p>
            <div className="mt-auto" data-id="element-322">
              <div className="font-bold text-white text-base" data-id="element-323">{t.name}</div>
              <div className="flex items-center text-brand-accent text-xs mt-0.5 mb-1" data-id="element-324">
                <MapPin className="w-3 h-3 mr-1" data-id="element-325" /> {t.location}
              </div>
              <div className="text-gray-400 text-xs" data-id="element-326">{t.role}</div>
            </div>
          </div>)}
      </div>
    </Section>;
}